import { Lifecycle } from '@dap/memberadmin/types';
import { Palette } from '@mui/material/styles';

export function getLifecycleChipBackgroundColor(
  lifecycle: Lifecycle,
  palette: Palette
): string | undefined {
  switch (lifecycle) {
    case Lifecycle.ACTIVE:
      return undefined;
    case Lifecycle.DRAFT:
    case Lifecycle.PENDING:
      return palette.info.main;
    case Lifecycle.SUSPENDED:
    case Lifecycle.DEACTIVATED:
      return palette.warning.main;
    default:
      return undefined;
  }
}
